import getFirebase from "../../../firebase";
import {proposal} from "../../../globalState";
import {updateSumCosts} from "../updateSumCosts";
import {doc, getDoc, getFirestore} from "firebase/firestore";

export function importFromFirebase(
    importData,
    setTypeOfProperty,
    setTypeOfTemplate,
    setBuildingName,
    setRoomSimulationImage,
    setRoomSimulationImageDesc,
    setRideSimulationImage,
    setRideSimulationImageDesc,
    setNumOfUnit,
    setSetupFee,
    setSetupFeeBeforeDiscount,
    setServiceFee,
    setServiceFeeBeforeDiscount,
    setLocation,
    setCurrentLocation,
    setLogoImage,
    setHideIntroduction,
    setRide,
    setOwnerRevenue,
    setColumns,
    setRideItems,
    addSetItemsCount
) {
    return async (buildingName) => {
        if (!importData && !buildingName) {
            return;
        }
        getFirebase();
        const building = importData.trim() || buildingName.trim();


        const db = getFirestore(getFirebase());

        const docRef = doc(db, "my_tulu", building);
        let data = await getDoc(docRef);


        data = data.data();
        if (!data) return;

        proposal.editors = [];

        Object.keys(data).forEach((key) => {
            proposal[key] = data[key];
        });

        setTypeOfProperty(data.typeOfProperty);
        setTypeOfTemplate(data.typeOfTemplate);
        setBuildingName(data.buildingName);
        setRoomSimulationImage(data.roomSimulationImage);
        setRoomSimulationImageDesc(data.roomSimulationImageDesc);
        setRideSimulationImage(data.rideSimulationImage);
        setRideSimulationImageDesc(data.rideSimulationImageDesc);
        setNumOfUnit(data.numOfUnit);
        setSetupFee(data.setupFee);
        setSetupFeeBeforeDiscount(data.setupFeeBeforeDiscount);
        setServiceFee(data.serviceFee);
        setServiceFeeBeforeDiscount(data.serviceFeeBeforeDiscount);
        setLocation(data.location);
        setCurrentLocation(data.location);
        setLogoImage(data.logoImage);
        setHideIntroduction(data.hideIntroduction);
        setRide(data.ride);
        setOwnerRevenue(data.ownerRevenue);
        let newColumns = JSON.parse(data.columns);
        let ride = JSON.parse(data.rideItems);
        setColumns(newColumns);
        updateSumCosts(newColumns);

        if (ride && ride.length > 0 && ride[0] && data.ride) {
            setRideItems(ride);
        }

        if (newColumns) {
            addSetItemsCount({ride, newColumns});
        }
    };
}
